// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"62d04200","453":"961d2188","455":"a0014b49"}[chunkId] + ".chunk.js";
};